const insuranceRouteList = {
     Verification:"verification",
     VerificationDetails:"verification-Details",
     claimListing:"claim-listing",
     claimProcessing: "claim-processing",
     claimDownloadView:"claim-download-view",
     processedClaims: "processed-claims",
     priorApprovalDashboard: "prior-approval-dashboard",
     priorApprovalPatientEdit:"prior-approval-edit",
     remittanceDashboard: "remittance-dashboard",
     resubmissionProcessing: "resubmission-processing",
     resubmission: "resubmission",
     emrVerificationDetails: "emr-verification-details",
     receptionVerification: "reception-verification",
     receptionVerificationForm: "reception-verification-form",
     vitalVerification: "vitals-verfication",
     vitalVerificationDetails: "vitals-verfication-details",
     emrVerification: "emr-verification",
     insuranceDashboard:"insuranceDashboard",
     auditLog:"audit-log",
     auditlogLanding:`auditlog-patient-list`,
     patientClaimList: "patient-claim-list",
}

export default insuranceRouteList